import { LoginPageComponent } from '@agent-ds/shared/pages/login-page/login-page.component';
import { NotFoundPageComponent } from './not-found-page/not-found-page.component';
import { OutlookListComponent } from './outlook-list/outlook-list.component';

export const SHARED_PAGES = [NotFoundPageComponent, LoginPageComponent, OutlookListComponent];
